// extracted by mini-css-extract-plugin
export var logo = "_m3-2";
export var logoWrapper = "_m3-1";
export var strip = "_m3-0";